const getBackendUrl = (): string => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const backendPort = '3002';

  return `${protocol}//${hostname}:${backendPort}`;
};

const getWebSocketUrl = (): string => {
  if (import.meta.env.VITE_WS_URL) {
    return import.meta.env.VITE_WS_URL;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const hostname = window.location.hostname;
  const wsPort = '1234';

  return `${protocol}//${hostname}:${wsPort}`;
};

export const API_BASE = getBackendUrl();
export const WS_BASE = getWebSocketUrl();

